export const handleImageLink = image => {
	if (image?.includes("http")) {
		return image;
	} else {
		// eslint-disable-next-line no-undef
		return `${process.env.REACT_APP_MAIN_URL}/${image}`;
	}
};

export const numberWithCommas = number => {
	// Convert the number to a string
	const numberString = number?.toString();

	// Use regular expression to add commas every three digits
	return numberString?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
